<div class="bulk-upload-supported-values" role="note" [attr.aria-label]="title">
    <h5 class="bulk-upload-supported-values-title">{{ title }}</h5>

    <div class="bulk-upload-supported-field" *ngFor="let field of fields">
        <h6 class="bulk-upload-supported-field-label">{{ field.label }}</h6>
        <ul class="bulk-upload-supported-field-list">
            <li *ngFor="let value of field.values">{{ value }}</li>
        </ul>
    </div>

    <p class="helper-text bulk-upload-supported-values-tip" *ngIf="tip">
        <strong>Tip:</strong>
        <ng-container *ngIf="isStructuredTip(tip); else plainTip">
            {{ tip.lead }}<strong *ngIf="tip.emphasis">{{ tip.emphasis }}</strong>{{ tip.trail }}
        </ng-container>
        <ng-template #plainTip>{{ tip }}</ng-template>
    </p>
</div>
